export default "__VITE_ASSET__BahHdsPy__"